import accessibility from './accessibility'
import exclusiveDealsTerms from './exclusiveDealsTerms'
import recoveryAiTerms from './recoveryAiTerms'
import settlementCredits from './settlementCredits'

export default {
  accessibility: accessibility,
  common: {
    legal_container: {
      copyright: '%{year} Thanx',
    },
  },
  exclusive_deals_terms: exclusiveDealsTerms,
  recovery_ai_terms: recoveryAiTerms,
  settlement_credits: settlementCredits,
}
